class FreeShippingBadge extends HTMLElement {
  connectedCallback() {
    const productCard = this.closest('product-card');
    
    if (productCard) {
      // Para product cards: leer el data attribute
      const hasFreeShipping = productCard.getAttribute('data-free-shipping') === 'true';
      
      if (hasFreeShipping) {
        this.removeAttribute('hidden');
        this.style.display = 'flex';
      } else {
        this.setAttribute('hidden', '');
        this.style.display = 'none';
      }
    } else {
      // Para product page: siempre visible si el elemento existe
      this.removeAttribute('hidden');
      this.style.display = 'flex';
    }
  }
}

if (!customElements.get('free-shipping-badge')) {
  customElements.define('free-shipping-badge', FreeShippingBadge);
}